"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _RecentTradesComponent = _interopRequireDefault(require("../RecentTrades/RecentTradesComponent"));
var _futuresOrdersSelectors = require("../../redux/futures/selectors/futuresOrdersSelectors");
var _selectors = require("../../redux/futures/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    recentTrades: (0, _futuresOrdersSelectors.futuresRecentTradesSelector)(state),
    fetching: (0, _futuresOrdersSelectors.futuresRecentTradesFetchingSelector)(state),
    selectedInstrument: (0, _selectors.futuresSelectedInstrumentSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_RecentTradesComponent["default"]);